import * as React from 'react';
import { IRestBoardCommonActivity } from '../../../../../../../../types/rest/activity/IRestBoardCommonActivity';
import { IActivityProps } from '../../types';
import { TActivity } from '../../../../../../../../store/activities/types';
import { ActivityHeader } from '../ActivityHeader/ActivityHeader';
import { ActivityItemBody } from '../ActivityItemBody/ActivityItemBody';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`BoardActivityRestore`) : null;

export function BoardActivityRestore ({
    activity
}: IActivityProps<IRestBoardCommonActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} activity={activity} />}
            activity={activity}
        />
    );
}
